<table id="tabela-hist-directOfertas" class="table table-striped"  *ngIf="histDirectOfertas.length > 0" aria-label="Direcionamento de ofertas">
  <thead>
  <tr>
    <th scope="col">Protocolo</th>
    <th scope="col">Data da solicitação</th>
    <th scope="col">Origem</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let oferta of histDirectOfertas">
    <td>{{ oferta.protocol | naoinformado }}</td>
    <td>{{ oferta.createDate | date:"dd/MM/yyyy" | naoinformado }}</td>
    <td>{{ oferta.origin | naoinformado }}</td>
  </tr>
  </tbody>
</table>

<div class="mensagem-hist-directOfertas" id="id-mensagem-hist-directOfertas" *ngIf="histDirectOfertas.length == 0">Nenhum histórico encontrado.</div>
